// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsergroupDeleteOutlinedSvg from "@ant-design/icons-svg/es/asn/UsergroupDeleteOutlined";
import AntdIcon from '../components/AntdIcon';

var UsergroupDeleteOutlined = function UsergroupDeleteOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsergroupDeleteOutlinedSvg
  }));
};

UsergroupDeleteOutlined.displayName = 'UsergroupDeleteOutlined';
export default React.forwardRef(UsergroupDeleteOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UsergroupDeleteOutlined.js
// module id = 2017
// module chunks = 0